import { render, staticRenderFns } from "./AppDataTable.vue?vue&type=template&id=677dbd7e&scoped=true&"
import script from "./AppDataTable.vue?vue&type=script&lang=js&"
export * from "./AppDataTable.vue?vue&type=script&lang=js&"
import style0 from "./AppDataTable.vue?vue&type=style&index=0&id=677dbd7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677dbd7e",
  null
  
)

export default component.exports